import firebase from 'firebase/app'

const firebaseConfig = {
    apiKey: "AIzaSyC0GgM-HUOeE1riBjkVdIl-0pgDL_daLVQ",
    authDomain: "web-app-43811.firebaseapp.com",
    databaseURL: "https://web-app-43811.firebaseio.com",
    projectId: "web-app-43811",
    storageBucket: "web-app-43811.appspot.com",
    messagingSenderId: "269912740152",
    appId: "1:269912740152:web:b241ce705b369ddeed31cd"
};

firebase.initializeApp(firebaseConfig);

export { firebaseConfig }